module.exports = __webpack_public_path__ + "static/media/expertrons.7f0329d0.webp";